export const MUHeaderElements = [
  {
    label: "Nombre",
    value: "nombre",
  },
  {
    label: "Apellido",
    value: "apellido",
  },
  {
    label: "DNI",
    value: "documento",
  },
  {
    label: "Mail",
    value: "mail",
  },
  {
    label: "Celular",
    value: "movil",
  },
  {
    label: "Estado",
    value: "estado",
  },
];
